import * as ActionTypes from '../constants/ActionTypes'
import { getRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

export function changeFields(fields){
  return {
    type: ActionTypes.SET_FIELDS,
    fields: fields
  }
}

const getTasks = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
    (response) => {
      dispatch(setData(response.data.user, 'user'));
      dispatch(setData(response.data.tasks, 'tasks'));
      dispatch(setData(response.data.material, 'material'));
      dispatch(setData(response.data.evidencia[0], 'evi'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

const getTask = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
    (response) => {
      dispatch(setData(response.data.tarea[0], 'tarea'));
      dispatch(setData(response.data.adjuntos, 'adjuntos'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

const getTaskInfo = (data, fields, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
    (response) => {
      dispatch(setData(response.data.entregas[0], 'entregas'));
      fields.message = response.data.entregas[0].contenido;
      dispatch(changeFields(fields));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

export default {
  getTasks,
  getTask,
  setData,
  getTaskInfo,
  changeFields
}
